<template>
  <transactions-list ref="transactionsList" :data-func="getTransactions" :show-user="true" />
</template>
<script>
  import transactionService from '../../../../services/transaction.service'

  import transactionsList from '../../../common/transactions-list.vue'

  export default {
    name: 'player-trans-bets',
    components: { transactionsList },
    props: {
      provider: {
        type: String,
        required: true
      }
    },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      }
    },
    watch: {
      async provider() {
        await this.$refs.transactionsList.reset();
      }
    },
    methods: {
      async getTransactions(filter) {
        filter.userId = this.playerId;
        filter.provider = this.provider;
        return await transactionService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/trans-bets.vue